(function () {
  const DESKTOP_BREAKPOINT = 1000;

  function initSection(root) {
    if (!root || root.dataset.mowowMscInit === "1") return;
    root.dataset.mowowMscInit = "1";

    const cardsShell = root.querySelector("[data-cards-shell]");
    const cardsContainer = root.querySelector("[data-group-cards]");
    const layoutContainer = root.querySelector(".container");

    if (!cardsShell || !cardsContainer || !layoutContainer) return;

    const cards = Array.from(root.querySelectorAll("[data-group-card]"));
    if (!cards.length) return;

    const tabs = Array.from(root.querySelectorAll("[data-group-tab]"));
    const defaultGroup = root.dataset.defaultGroup || cards[0].dataset.group || "default";

    const prevBtn = root.querySelector("[data-prev]");
    const nextBtn = root.querySelector("[data-next]");

    const canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    let activeGroup = defaultGroup;
    let step = 0;

    function isDesktop() {
      return window.innerWidth >= DESKTOP_BREAKPOINT;
    }

    function visibleCards() {
      return cards.filter((card) => !card.hidden && card.dataset.group === activeGroup);
    }

    function getGap() {
      const style = window.getComputedStyle(cardsContainer);
      const gap = parseFloat(style.columnGap || style.gap || "0");
      return Number.isFinite(gap) ? gap : 0;
    }

    function updateLayoutVars() {
      const rootRect = root.getBoundingClientRect();
      const containerRect = layoutContainer.getBoundingClientRect();
      const leftPad = Math.max(0, containerRect.left - rootRect.left);

      root.style.setProperty("--mowow-msc-pad-left", `${leftPad}px`);

      if (isDesktop()) {
        const gap = getGap() || 20;
        const cardWidth = Math.max(220, (containerRect.width - gap * 2) / 3);
        root.style.setProperty("--mowow-msc-card-width", `${cardWidth}px`);
      }
    }

    function updateStep() {
      const visible = visibleCards();

      if (!visible.length) {
        step = 0;
        return visible;
      }

      if (visible.length > 1) {
        step = visible[1].offsetLeft - visible[0].offsetLeft;
      }

      if (!step || step < 1) {
        step = visible[0].getBoundingClientRect().width + getGap();
      }

      return visible;
    }

    function getMaxIndex(visible) {
      const slots = isDesktop() ? 3 : 1;
      return Math.max(0, visible.length - slots);
    }

    function getCurrentIndex(visible) {
      if (!visible.length || !step) return 0;
      const raw = Math.round(cardsContainer.scrollLeft / step);
      const max = getMaxIndex(visible);
      return Math.max(0, Math.min(max, raw));
    }

    function scrollToIndex(index, smooth) {
      const visible = updateStep();
      if (!visible.length || !step) return;

      const max = getMaxIndex(visible);
      const safe = Math.max(0, Math.min(max, index));

      cardsContainer.scrollTo({
        left: safe * step,
        behavior: smooth === false ? "auto" : "smooth",
      });
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;

      const visible = updateStep();
      const max = getMaxIndex(visible);
      const current = getCurrentIndex(visible);

      const hideNav = max === 0;
      prevBtn.disabled = hideNav || current <= 0;
      nextBtn.disabled = hideNav || current >= max;

      prevBtn.style.visibility = hideNav ? "hidden" : "visible";
      nextBtn.style.visibility = hideNav ? "hidden" : "visible";
    }

    function stopCardVideo(card) {
      const video = card.querySelector("video.mowow-msc__video");
      if (!video) return;

      try {
        video.pause();
        video.currentTime = 0;
      } catch (e) {}

      card.classList.remove("is-video-playing");
    }

    function stopAllVideos() {
      cards.forEach(stopCardVideo);
    }

    function playCardVideo(card) {
      if (!canHover || reducedMotion || card.hidden) return;

      const video = card.querySelector("video.mowow-msc__video");
      if (!video) return;

      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === "function") {
        playPromise
          .then(function () {
            card.classList.add("is-video-playing");
          })
          .catch(function () {});
      } else {
        card.classList.add("is-video-playing");
      }
    }

    function setGroup(group) {
      activeGroup = group || defaultGroup;
      stopAllVideos();

      cards.forEach((card) => {
        card.hidden = card.dataset.group !== activeGroup;
      });

      tabs.forEach((tab) => {
        const active = tab.dataset.group === activeGroup;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
      });

      window.requestAnimationFrame(function () {
        updateLayoutVars();
        cardsContainer.scrollLeft = 0;
        updateNavState();
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        setGroup(tab.dataset.group);
      });
    });

    cards.forEach((card) => {
      if (!canHover) return;
      if (!card.querySelector("video.mowow-msc__video")) return;

      card.addEventListener("mouseenter", function () {
        playCardVideo(card);
      });

      card.addEventListener("mouseleave", function () {
        stopCardVideo(card);
      });
    });

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener("click", function () {
        const visible = updateStep();
        scrollToIndex(getCurrentIndex(visible) - 1, true);
      });

      nextBtn.addEventListener("click", function () {
        const visible = updateStep();
        scrollToIndex(getCurrentIndex(visible) + 1, true);
      });
    }

    let raf = null;
    cardsContainer.addEventListener(
      "scroll",
      function () {
        if (raf) window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(updateNavState);
      },
      { passive: true }
    );

    window.addEventListener(
      "resize",
      function () {
        const visible = updateStep();
        const current = getCurrentIndex(visible);

        updateLayoutVars();

        window.requestAnimationFrame(function () {
          scrollToIndex(current, false);
          updateNavState();
        });
      },
      { passive: true }
    );

    setGroup(defaultGroup);
  }

  function init(root) {
    (root || document).querySelectorAll("[data-mowow-model-cards]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target || document);
  });
})();
